import React, { useEffect, useState } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import { verifyOwnerUrl } from '../../../common-url/CommonUrl'
import SVG from "react-inlinesvg";
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';

export default function OwnerTransfer() {
    useEffect(() => {
        verifyUser()
    }, [])
    const [code, setCode] = useState()
    const [fullname, setFullname] = useState()

    let { id } = useParams();

    const verifyUser = async () => {
        await fetch(verifyOwnerUrl + `/owner-transfer-verify/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setCode(response.code)
                // console.log(response, "response............")
                if (response.code == 200 || response.code == 201) {
                    setFullname(response.data.vFullName)
                } else {
                    setFullname("")
                }
            });
    }

    if (code == 200) {
        return (
            <>
                <div class=" row text-center">
                    <label className="text-dark col-form-label">
                        <h4 className="display-4 font-weight-bolder">Success..!</h4>
                    </label>

                    <div class=" col-sm-4 offset-sm-4 mt-10">
                        <div className="svg-icon svg-icon-3x svg-icon-success rounded-circle border border-success svg-verified">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")} />
                        </div>
                    </div>
                    <label className="text-dark font-weight-bolder my-10">
                        <h4 className="display-4">Hello {fullname}..!</h4>
                    </label>
                    <h5 className="text-center d-flex flex-column">
                        <span className="font-weight-bolder font-size-lg text-dark-75 lh-base">Your Ownership has been successfully transfered.</span>
                        <span className="font-weight-mormal font-size-lg text-muted lh-base">You can now access the features of your parent account.</span>
                    </h5>

                </div>
            </>
        )
    } else if (code == 201) {
        return (
            <>
                <div class=" row text-center mt-n20">
                    <label className="text-dark col-form-label">
                        <h4 className="display-4 font-weight-bolder">Already Transfered...</h4>
                    </label>
                    <div class=" col-sm-4 offset-sm-4 mt-10">
                        <div className="svg-icon svg-icon-3x svg-icon-warning rounded-circle border border-warning svg-verified">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")} />
                        </div>
                    </div>
                    <label className="text-dark font-weight-bolder my-10">
                        <h4 className="display-4">Hello {fullname}..!</h4>
                    </label>
                    <h5 className="text-center d-flex flex-column">
                        <span className="font-weight-bolder font-size-lg text-dark-75 lh-base">Your Ownership is already transfered.</span>
                        <span className="font-weight-mormal font-size-lg text-muted lh-base">You can now access the features of your parent account.</span>
                    </h5>
                </div>
            </>
        )
    } else if (code == 401 || code == 400) {
        return (
            <>
                <div class=" row text-center mt-n20">
                    <label className="text-dark col-form-label">
                        <h4 className="display-4 font-weight-bolder">Invalid Link...</h4>
                    </label>
                    <div class=" col-sm-4 offset-sm-4 mt-10">
                        <div className="svg-icon svg-icon-3x svg-icon-danger rounded-circle border border-danger svg-verified">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-1-circle.svg")} />
                        </div>
                    </div>
                    <label className="text-dark font-weight-bolder my-10">
                        <h4 className="display-4">Hello..!</h4>
                    </label>
                    <h5 className="text-center d-flex flex-column">
                        <span className="font-weight-bolder font-size-lg text-dark-75 lh-base">Your Owner Transfer Link is Invalid.</span>
                        <span className="font-weight-mormal font-size-lg text-muted lh-base">Please Try Again.</span>
                    </h5>
                </div>
            </>)
    }
    else {
        return (
            <>
                <CircularProgress disableShrink />
            </>
        )
    }
}
